import { request } from "../api";
import { env } from "../env";

export interface ReportEnvelope<TRow, TSummary> {
  summary: TSummary;
  rows: TRow[];
}

export interface DeviceHealthSummary {
  total_devices: number;
  active_devices: number;
  stale_devices: number;
  never_seen_devices: number;
  latest_policy_ack_missing: number;
}

export interface DeviceHealthRow {
  device_id: string;
  device_uid: string;
  user_email: string;
  user_full_name: string;
  platform: string;
  model: string;
  app_version: string;
  os_version: string;
  last_seen_at: string | null;
  status: string;
  current_policy_version: number | null;
  last_acknowledged_policy_version: number | null;
  last_policy_ack_at: string | null;
}

export type ReportName = "device-health";

function qs(params: object): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params) as [string, unknown][]) {
    if (v === undefined || v === "" || v === null) continue;
    sp.append(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : "";
}

export const reportsApi = {
  getDeviceHealth: (filters: Record<string, unknown> = {}) =>
    request<ReportEnvelope<DeviceHealthRow, DeviceHealthSummary>>(
      `/api/admin/v1/reports/device-health/${qs(filters)}`,
    ),
  /** Build an export URL for the given report and format. Uses VITE_API_BASE_URL. */
  exportUrl: (
    name: ReportName,
    format: ExportFormat,
    filters: Record<string, unknown> = {},
  ) => {
    const combined = { ...filters, format };
    return `${env.API_BASE_URL}/api/admin/v1/reports/${name}/${qs(combined)}`;
  },

};

export type ExportFormat = "csv" | "xlsx";

export const EXPORT_FORMAT_FILENAMES: Record<ExportFormat, (stem: string) => string> = {
  csv: (stem) => `${stem}.csv`,
  xlsx: (stem) => `${stem}.xlsx`,
};
